import CheckCircleFill from '@/components/icons/Action/CheckCircleFill';
import ErrorFill from '@/components/icons/Action/ErrorFill';
import InfoFill from '@/components/icons/Action/InfoFill';
import WarningFill from '@/components/icons/Action/WarningFill';
import { FC } from 'react';
import styles from './style.module.scss';

export type AlertType = 'information' | 'success' | 'warning' | 'danger';

export type AlertProps = {
  title?: string;
  message?: string;
  type: AlertType;
};

export const Alert: FC<AlertProps> = ({ title, message, type }) => {
  const pickIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleFill />;
      case 'danger':
        return <ErrorFill />;
      case 'information':
        return <InfoFill />;
      case 'warning':
        return <WarningFill />;
      default:
        return '';
    }
  };

  return (
    <div className={`gap-xs flex-column ${styles.container} ${styles[type]}`}>
      <div className={`gap-xs flex-row ${styles.content}`}>
        {pickIcon()}
        <div className={`gap-xs flex-column`}>
          {title && <h5>{title}</h5>}
          {message && <p>{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default Alert;
